import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function Form() {
    const profileFilter = chooseProfileFilter();

    const hiddenValues = {};

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id;
    }

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const navigate = useNavigate();

    const path = '/gci/suppliers/';
    const paths = {
        endpointSave: config.endpoints.backend + 'gci/suppliers/save',
        endpointGetById: config.endpoints.backend + 'gci/suppliers/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'gci/companies/getall',
        endpointGetAllBanks: config.endpoints.backend + 'gci/banks/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleAdd: 'Novo Fornecedor',
        labelTitleEdit: 'Editar Fornecedor',
        labelTitleView: 'Visualizar Fornecedor'
    };

    const getForm = (values) => {
        const supplier_type = values.supplier_type;

        const form = {
            validateOnChange: true,
            hiddenValues: { ...hiddenValues },
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'supplier_type',
                    type: 'select',
                    options: [
                        { label: 'Física', value: 'F' },
                        { label: 'Jurídica', value: 'J' },
                        { label: 'Estrangeiro', value: 'E' },
                        { label: 'Sem documento', value: 'S' }
                    ],
                    label: 'Tipo de Fornecedor',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        const form = getForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />
                        );
                    }
                },
                ...(['F', 'E', 'S'].includes(supplier_type)
                    ? [
                          {
                              name: 'name',
                              type: 'text',
                              label: 'Nome',
                              validations: { required: true },
                              columnSize: 12
                          },
                          supplier_type === 'F'
                              ? {
                                    name: 'cpf',
                                    type: 'CPF',
                                    label: 'CPF',
                                    validations: { required: true },
                                    columnSize: 4
                                }
                              : {
                                    name: 'document',
                                    type: 'text',
                                    label: 'Documento',
                                    validations: { required: supplier_type === 'E' },
                                    columnSize: 4
                                },
                          {
                              name: 'rg',
                              type: 'RG',
                              label: 'RG',
                              validations: { required: false },
                              columnSize: 4
                          },
                          {
                              name: 'birth_date',
                              type: 'date',
                              label: 'Data de Nascimento',
                              validations: { required: false },
                              columnSize: 4
                          }
                      ]
                    : [
                          {
                              name: 'corporate_name',
                              type: 'text',
                              label: 'Razão Social',
                              validations: { required: true },
                              columnSize: 12
                          },
                          {
                              name: 'fantasy_name',
                              type: 'text',
                              label: 'Nome Fantasia',
                              validations: { required: false },
                              columnSize: 12
                          },
                          {
                              name: 'cnpj',
                              type: 'CNPJ',
                              label: 'CNPJ',
                              validations: { required: true },
                              columnSize: 6
                          },
                          {
                              name: 'estadual_registration',
                              type: 'text',
                              label: 'Inscrição Estadual',
                              validations: { required: false },
                              columnSize: 6
                          },
                          {
                              name: 'opening_date',
                              type: 'date',
                              label: 'Data de Abertura',
                              validations: { required: false },
                              columnSize: 6
                          }
                      ]),
                {
                    label: 'Tipo de Endereço',
                    name: 'type_address',
                    type: 'select',
                    options: [
                        { label: 'Comercial', value: 'COMERCIAL' },
                        { label: 'Residencial', value: 'RESIDENCIAL' },
                        { label: 'Cobrança', value: 'COBRANCA' },
                        { label: 'Entrega', value: 'ENTREGA' }
                    ],
                    validations: { required: true },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: { required: true },
                    columnSize: 12
                },
                {
                    name: 'contact_name',
                    type: 'text',
                    label: 'Nome do Contato',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'contact_role',
                    type: 'text',
                    label: 'Função',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'contact_email',
                    type: 'email',
                    label: 'E-mail do Contato',
                    validations: { required: false },
                    columnSize: 12
                },
                {
                    label: 'Tipo de Telefone',
                    name: 'phone_type',
                    type: 'select',
                    options: [
                        { label: 'Tel. Fixo', value: 'TELFIXO' },
                        { label: 'Celular', value: 'CELULAR' },
                        { label: 'Comercial', value: 'COMERCIAL' },
                        { label: 'Tel. Institucional', value: 'TELINSTITUCIONAL' },
                        { label: 'Recado', value: 'RECADO' }
                    ],
                    validations: { required: false },
                    columnSize: 12
                },
                {
                    name: 'phone',
                    type: 'phone',
                    label: 'Telefone',
                    validations: { required: false },
                    columnSize: 12
                },
                {
                    name: 'gci_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id'
                    },
                    validations: { required: false },
                    columnSize: 12
                },
                {
                    name: 'agency_number',
                    type: 'integer',
                    label: 'Número da Agência',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'agency_digit',
                    type: 'text',
                    label: 'Dígito da Agência (Substitua X por 0)',
                    mask: '9',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'account_number',
                    type: 'integer',
                    label: 'Número da Conta',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'account_digit',
                    type: 'text',
                    label: 'Dígito da Conta (Substitua X por 0)',
                    mask: '9',
                    validations: { required: false },
                    columnSize: 6
                },
                {
                    name: 'pix_key',
                    type: 'text',
                    label: 'Chave PIX',
                    validations: { required: false },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: { required: true },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );

            navigate('/gci/suppliers/add', { replace: true });
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}

export default Form;
